module.exports = __webpack_public_path__ + "img/icon-tel.feec4540.svg";